import type { BookingField, BookingTexts } from '@/components/feature/BookingCalendar';

// Booking calendar endpoints. Replace both with your own calendar's endpoints to use your calendar.
// If left empty or invalid, the widget makes no requests and shows a "booking unavailable" state.
export const BOOKING_TIMESLOTS_API = 'https://readdy.ai/api/public/calendar/timeslots/7db545c9-6fd6-4ef8-869f-c3efb0502cd3.658c06eb0a5451c27fff06acb97f59fb88095c640414a4c33c34ebc8e68c0c60';
export const BOOKING_APPOINTMENTS_API = 'https://readdy.ai/api/public/calendar/appointments/7db545c9-6fd6-4ef8-869f-c3efb0502cd3.658c06eb0a5451c27fff06acb97f59fb88095c640414a4c33c34ebc8e68c0c60';

const ENDPOINT = /^https:\/\/readdy\.ai\/api\/public\/calendar\/(timeslots|appointments)\/[A-Za-z0-9.-]+$/;

/** True only when both endpoints are well-formed and refer to the same calendar. */
export const isBookingConfigured = (timeslots: string, appointments: string): boolean => {
  const a = ENDPOINT.exec(timeslots);
  const b = ENDPOINT.exec(appointments);
  if (!a || !b || a[1] !== 'timeslots' || b[1] !== 'appointments') return false;
  return timeslots.split('/').pop() === appointments.split('/').pop();
};

// Length of one bookable appointment in minutes. The calendar returns open windows that are split by this value.
export const BOOKING_SLOT_MINUTES = 60;

export const bookingTexts: BookingTexts = {
  stepDate: 'Date', stepTime: 'Time', stepDetails: 'Details',
  prevMonth: 'Previous month', nextMonth: 'Next month',
  weekdays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  loading: 'Loading available times…',
  loadError: 'We couldn’t load available times.',
  retry: 'Try again',
  noSlots: 'No appointment times are open right now.',
  selectTime: 'Choose a time',
  back: 'Back to dates',
  reviewTitle: 'Your selected time',
  dateLabel: 'Date', timeLabel: 'Time',
  modifyTime: 'Modify time',
  submit: 'Confirm Booking', submitting: 'Booking…',
  requiredError: 'Please fill in your name and phone number.',
  successTitle: 'Booking received',
  successBody: 'Your appointment has been recorded. The studio will contact you if anything changes.',
  bookAnother: 'Book another',
  submitError: 'Booking failed. Your details are kept — please try again.',
  pickDateHint: 'Select a highlighted date to see available times.',
  noSlotsDay: 'No times left on this date. Please choose another day.',
  continueLabel: 'Continue to details',
  selectedLabel: 'Selected',
  conflict: 'Sorry, that time was just taken. Please choose another time — your details are kept.',
  unavailableTitle: 'Online booking is not open yet',
  unavailableBody: 'Our online calendar is being set up. Please check back soon or contact the studio directly to arrange your visit.',
};

export const bookingFields: BookingField[] = [
  { name: 'customer_name', label: 'Name', type: 'text', required: true },
  { name: 'customer_phone', label: 'Phone', type: 'tel', required: true },
  { name: 'service', label: 'Service of interest', type: 'text', placeholder: 'e.g. Cut, colour, consultation' },
  { name: 'stylist', label: 'Preferred stylist', type: 'text', placeholder: 'Optional' },
  { name: 'notes', label: 'Notes', type: 'textarea', placeholder: 'Anything we should know (max 500 characters)' },
];